module.exports = __webpack_public_path__ + "static/media/square-plus-orange.d4002b72.png";